export default {
    title: 'Capabilities & Assets'
}
